import { PAGE_PATHS } from '../constants';

const operationActivities = (operationId: string, activityId?: string): string => {
  const bookmark = (activityId !== undefined) ? `#activity_${activityId}` : '';
  return `${PAGE_PATHS.operations}/${operationId}/activities${bookmark}`;
};

const operationIncident = (operationId: string, incidentId: string): string => {
  return `${PAGE_PATHS.operations}/${operationId}/incidents/${incidentId}`;
};

export const PagePaths = {
  operationActivities,
  operationIncident
};
